/**
 * Pure selectors for fresh-straw data. Exist as their own module so they can
 * be unit-tested without touching RTK Query, Redux, or component rendering.
 */

export interface FreshStrawRowMathSource {
  clientTransfer?: number | null;
  clientFrozen?: number | null;
  clientDiscarded?: number | null;
  clientShipped?: number | null;
}

/**
 * Verifies each fertilization row obeys the invariant
 *   clientTransfer + clientFrozen - clientDiscarded === clientShipped
 * Extracted from FreshStrawContext.tsx:144-154 so that Phase 2 components can
 * read the result from a plain function instead of a stateful context.
 */
export function selectFertilizationRowMath(
  fertilizations: readonly FreshStrawRowMathSource[] | null | undefined,
): boolean {
  if (!fertilizations || fertilizations.length === 0) return true;

  return fertilizations.every((row) => {
    const transfer = row.clientTransfer ?? 0;
    const frozen = row.clientFrozen ?? 0;
    const discarded = row.clientDiscarded ?? 0;
    const shipped = row.clientShipped ?? 0;
    return transfer + frozen - discarded === shipped;
  });
}
